import * as React from 'react'
import { ReactNode } from 'react'
import { Style } from 'node:util'

interface IYumButtonGroup {
  children: ReactNode
  style?: object
}

const YumButtonGroup = ({ children, style }: IYumButtonGroup) => {
  return <div style={{ display: 'flex', gap: '24px', width: '100%', ...style }}>{children}</div>
}

export default YumButtonGroup
